<div class="coverage-detail" *ngIf="!changeCoverage">
    <ins-insurance-coverage-data [purchasedProduct]="purchasedProduct"></ins-insurance-coverage-data>
    <div class="coverage-detail__buttons">
        <ins-insurance-coverage-buttons
            [purchasedProduct]="purchasedProduct"
            (toggleChangeCoverage)="toggleChangeCoverage()"
        ></ins-insurance-coverage-buttons>
        <p>
            <small>
                Alle genoemde prijzen zijn in euro's inclusief assurantiebelasting. En exclusief het geld dat u achteraf
                misschien terugkrijgt in de vorm van JaarBalans.
                <a href="" (click)="getInfo()">Wat is dit?</a>
            </small>
        </p>
    </div>
</div>
<div class="coverage-detail" *ngIf="changeCoverage">
    <ins-insurance-coverage-form
        [purchasedProduct]="purchasedProduct"
        [relation]="relation"
    ></ins-insurance-coverage-form>
</div>
